import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { httpInterceptor } from "./modules/common/HttpInterceptor";
import store from "./store/Store";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

httpInterceptor.setupInterceptors(store);
const root = createRoot(document.getElementById("root"));

window.addEventListener("load", function () {
  setTimeout(function () {
    window.scrollTo(0, 1);
  }, 0);
});

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
